<template>
  <Card class="box" title="办文单信息">
    <Spin fix v-if="showPageLoading"></Spin>
    <div style="padding: 10px;">
      <template v-if="data.recheckNoPassReason">
        <Divider orientation="left"><span>
            退回理由
          </span></Divider>
        <Alert style="white-space: break-spaces; line-height: 22px;" type="error">{{ data.recheckNoPassReason }}</Alert>
      </template>
      <!-- <Divider :style="data.recheckNoPassReason?'margin-top:40px;':''" orientation="left"><span>
          办文单信息
        </span></Divider> -->

      <table class="table_flower">
        <tr>
          <th style="width: 40%;">落户类型</th>
          <td style="width: 60%;">{{ data.applicationTypeText }}</td>
        </tr>
        <tr>
          <th>办文单号</th>
          <td>{{ data.documentNumber }}</td>
        </tr>
        <tr>
          <th>申请人姓名</th>
          <td>{{ data.serverData.person.f_name }}</td>
        </tr>
        <tr>
          <th>申请人身份证号</th>
          <td>{{ data.identityNumber }}</td>
        </tr>
        <tr>
          <th>单位名称</th>
          <td>{{ data.serverData.unitInfo.f_unitname }}</td>
        </tr>
        <tr>
          <th>统一社会信用代码（或组织机构代码）</th>
          <td>{{ data.serverData.unitInfo.f_unitcode }}</td>
        </tr>
      </table>

    </div>
    <Divider style="margin-top:40px;" orientation="left">电联任务
    </Divider>
    <div>
      <div class="cardList" v-for="(item,index) in data.phoneContactTaskDto" :key="index">
        <div class="card_box">
          <div class="card_title">
            <span>电联对象：</span> {{item.contactObjectText}}
          </div>
          <div class="card_title">
            <span>电联联系人：</span>{{item.applicant}}
          </div>
          <div class="card_title">
            <span>电联原因：</span>{{item.phoneContactReasonTypeText}}
          </div>
          <div class="card_title">
            <span>电联/撤销时间：</span>{{item.operatingTimeText}}
          </div>
          <div class="card_title">
            <span>状态：</span>{{item.statusText}}
          </div>
        </div>
      </div>
    </div>

    <Divider style="margin-top:40px;" orientation="left">提前干预
    </Divider>
    <div>
      <div class="cardList" v-for="(item,index) in data.interfereList" :key="index">
        <div class="card_box">
          <div class="card_title">
            <span>创建人：</span> {{item.creatorUserName}}
          </div>
          <div class="card_title">
            <span>提醒/干预内容：</span>{{item.remindContent}}
          </div>
          <div class="card_title">
            <span>提醒/干预环节：</span>{{item.remindLinkText}}
          </div>
          <div class="card_title">
            <span>提醒/干预人员：</span>{{item.remindUserName}}
          </div>
          <div class="card_title">
            <span>提醒类型：</span>{{item.typeText}}
          </div>
          <div class="card_title">
            <span>创建时间：</span> {{item.creationTimeText}}
          </div>
          <div class="card_title">
            <span>已阅时间：</span> {{item.readTimeText}}
          </div>
        </div>
      </div>
    </div>
    <div>
      <Divider style="margin-top:40px;" orientation="left">审批记录
        <span style="color:red;">[申报次数：{{ data.serverData.person.f_sbcs }}]

        </span>
      </Divider>
      <div>
        <div class="cardList" v-for="(item,index) in data.serverData.approveHistorieList" :key="index">
          <div class="card_box">
            <div class="card_title">
              <span>节点：</span> {{item.f_stepstart}}
            </div>
            <div class="card_title">
              <span>办理人员：</span>{{item.f_username}}
            </div>
            <div class="card_title">
              <span>时间：</span>{{item.f_approvedate}}
            </div>
            <div class="card_title">
              <span>结果：</span>{{item.f_approveresult}}
            </div>
            <div class="card_title">
              <span>下一节点：</span>{{item.f_stepend}}
            </div>
            <div class="card_title">
              <span>备注：</span> {{item.f_remark}}
            </div>
          </div>
        </div>
      </div>

    </div>
  </Card>
</template>
<script>
import '../residencePermitIntegral/styles/points.less'

export default {
  data() {
    return {
      data: {
        serverData: {
          person: {
            prclhPersonExt: {},
          },
          unitInfo: {},
        },
      },
      guid: '',
      m: '',
      toLinkType: '',
      showPageLoading: false,
      columnsApprove: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '节点',
          key: 'f_stepstart',
          align: 'center',
          width: 120,
        },
        {
          title: '办理人员',
          key: 'f_username',
          align: 'center',
          width: 120,
        },
        {
          title: '时间',
          key: 'f_approvedate',
          align: 'center',
          width: 180,
        },
        {
          title: '结果',
          key: 'f_approveresult',
          align: 'center',
          width: 120,
        },
        {
          title: '下一节点',
          key: 'f_stepend',
          align: 'center',
          width: 120,
        },
        {
          title: '备注',
          key: 'f_remark',
          align: 'center',
        },
      ],
    }
  },
  created() {
    // this.data = this.$route.query.data
    this.m = this.$route.query.m
    this.guid = this.$route.query.guid
    this.toLinkType = this.$route.query.type
    this.getInit()
  },
  methods: {
    // 获取详情
    async getInit() {
      this.showPageLoading = true
      try {
        if (this.guid) {
          let { data } = await this.$Ajax.get('/api/services/app/JZZJF/GetDocumentFormInfo', {
            params: { guid: this.guid, m: this.m },
          })

          data.result.serverData = data.result.lhApplicationJsonData.resultData

          this.data = data.result
        } else {
          this.$Message.error('未获取到数据')
          this.$router.back()
        }
      } catch (error) {
        this.$Modal.error({
          title: '错误',
          content: '未能正常打开',
        })
      }

      this.showPageLoading = false
    },
  },
}
</script>
<style lang="less" scoped>
.box {
  max-height: 100vh;
  overflow: auto;
}
/deep/.ivu-card-body {
  min-height: 100vh;
}
/deep/.archive.ivu-alert {
  padding: 8px 8px 8px 15px;
}
.card_box {
  padding: 10px 10px 0 10px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: #e8eaec 2px 2px 4px;
  .card_title {
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 120px;
      font-weight: 600;
    }
  }
}
// .card_title span::before {
//   content: '';
//   display: inline-block;
//   width: 3px;
//   height: 16px;
//   background: #3c9dff;
//   margin-right: 5px;
//   border-radius: 5px;
//   position: relative;
//   top: 2px;
// }
</style>